<template>
  <div class="chart-container">
    <Pie v-if="show" :chart-data="data" :chart-options="options" />
  </div>
</template>
<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'vue-chartjs'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  props: {
    data: Object,
    title: String,
  },
  name: 'App',
  components: {
    Pie,
  },
  data() {
    return {
      show: true,
    }
  },
  computed: {
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'left',
          },
        },
      }
    },
  },
  activated() {
    this.show = false
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.show = true
      })
    })
  },
}
</script>
<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
